import { Link, Outlet } from "react-router-dom";
import { useAuth } from "../../lib/useAuth";
import s from "./AdminGuard.module.css";

/**
 * Solo entra quien tenga el custom claim `admin`. El claim se asigna desde
 * consola con `npm run set-admin -- correo@dominio.com`.
 */
export default function AdminGuard() {
  const { user, isAdmin, loading, disponible, entrarConGoogle, salir } = useAuth();

  if (!disponible) {
    return (
      <Pantalla titulo="Panel no disponible">
        <p>
          El panel necesita Firebase configurado. Copia <code>.env.example</code>{" "}
          a <code>.env</code>, rellena las credenciales y reinicia el servidor.
        </p>
        <Link to="/" className="btn btn--ghost">
          Volver a la web
        </Link>
      </Pantalla>
    );
  }

  if (loading) {
    return (
      <Pantalla titulo="Verificando acceso">
        <p className="mono">Un momento...</p>
      </Pantalla>
    );
  }

  if (!user) {
    return (
      <Pantalla titulo="Panel de administracion">
        <p>Inicia sesion con la cuenta autorizada de Aceros Lima.</p>
        <button type="button" className="btn btn--accent" onClick={entrarConGoogle}>
          Entrar con Google
        </button>
        <Link to="/" className={s.volver}>
          &larr; Volver a la web
        </Link>
      </Pantalla>
    );
  }

  if (!isAdmin) {
    return (
      <Pantalla titulo="Sin permisos">
        <p>
          La cuenta <strong>{user.email}</strong> no tiene permisos de
          administrador.
        </p>
        <p className="hint">
          Un administrador puede habilitarla ejecutando:
          <br />
          <code className="mono">npm run set-admin -- {user.email}</code>
        </p>
        <div className={s.acciones}>
          <button type="button" className="btn btn--ghost" onClick={salir}>
            Cerrar sesion
          </button>
          <Link to="/" className="btn btn--accent">
            Volver a la web
          </Link>
        </div>
      </Pantalla>
    );
  }

  return <Outlet />;
}

function Pantalla({ titulo, children }) {
  return (
    <div className={s.pantalla}>
      <div className={s.caja}>
        <p className="eyebrow">Aceros Lima</p>
        <h1 className={s.titulo}>{titulo}</h1>
        {children}
      </div>
    </div>
  );
}
